import React from "react";
import getAPIbaseURL from "../../../utils/helpers";

const UserForm = ({
    form,
    errors,
    editMode,
    delegations,
    managers,
    roleOptions,
    employmentTypes,
    countries,
    handleInputChange,
    handleFileChange,
    touched = {}
}) => {
    return (
        <table className="table table-bordered">
            <tbody>
                <tr>
                    <th>ID</th>
                    <td>
                        <input className="form-control" value={form.id || ""} disabled />
                    </td>
                </tr>
                <tr>
                    <th>Username</th>
                    <td>
                        <input
                            className="form-control"
                            name="username"
                            value={form.username || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Email</th>
                    <td>
                        <input
                            className="form-control"
                            name="email"
                            value={form.email || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Role</th>
                    <td>
                        {editMode ? (
                            <select
                                className="form-select"
                                name="role_id"
                                value={form.role_id || ""}
                                onChange={handleInputChange}
                            >
                                {roleOptions.map((role) => (
                                    <option key={role.value} value={role.value}>
                                        {role.label}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            form.role?.name || roleOptions.find(r => r.value === form.role_id)?.label || form.role_id
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Status</th>
                    <td>
                        {editMode ? (
                            <select
                                className="form-select"
                                name="is_active"
                                value={form.is_active ? "true" : "false"}
                                onChange={e =>
                                    handleInputChange({
                                        target: {
                                            name: "is_active",
                                            value: e.target.value,
                                            type: "select-one"
                                        }
                                    })
                                }
                            >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        ) : (
                            form.is_active ? "Active" : "Inactive"
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Delegation</th>
                    <td>
                        {editMode ? (
                            <select
                                className="form-select"
                                name="delegation_id"
                                value={form.delegation_id || ""}
                                onChange={handleInputChange}
                            >
                                {delegations.map((delegation) => (
                                    <option key={delegation.id} value={delegation.id}>
                                        {delegation.name}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            delegations.find(d => d.id === form.delegation_id)?.name || form.delegation_id
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Employment Type</th>
                    <td>
                        {editMode ? (
                            <select
                                className="form-select"
                                name="employment_type"
                                value={form.employment_type || ""}
                                onChange={handleInputChange}
                            >
                                {employmentTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            form.employment_type
                        )}
                    </td>
                </tr>
                <tr>
                    <th>NIF</th>
                    <td>
                        <input
                            className={`form-control ${errors.nif && (touched.nif || editMode) ? "is-invalid" : ""}`}
                            name="nif"
                            value={form.nif || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                        {errors.nif && (touched.nif || editMode) && <div className="invalid-feedback">{errors.nif}</div>}
                    </td>
                </tr>
                <tr>
                    <th>IBAN</th>
                    <td>
                        <input
                            className={`form-control ${errors.iban && (touched.iban || editMode) ? "is-invalid" : ""}`}
                            name="iban"
                            value={form.iban || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                        {errors.iban && (touched.iban || editMode) && <div className="invalid-feedback">{errors.iban}</div>}
                    </td>
                </tr>
                <tr>
                    <th>CC</th>
                    <td>
                        <input
                            className={`form-control ${errors.cc && (touched.cc || editMode) ? "is-invalid" : ""}`}
                            name="cc"
                            value={form.cc || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                        {errors.cc && (touched.cc || editMode) && <div className="invalid-feedback">{errors.cc}</div>}
                    </td>
                </tr>
                <tr>
                    <th>Address</th>
                    <td>
                        <input
                            className="form-control"
                            name="address"
                            value={form.address || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Home Address</th>
                    <td>
                        <input
                            className="form-control"
                            name="home_address"
                            value={form.home_address || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Remote</th>
                    <td>
                        <input
                            type="checkbox"
                            name="remote"
                            checked={!!form.remote}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Profile Picture</th>
                    <td>
                        {editMode ? (
                            <>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="profile_picture"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                                {form.profile_picture && (
                                    <img
                                        src={form.profile_picture.startsWith("http") ? form.profile_picture : `${getAPIbaseURL()}${form.profile_picture}`}
                                        alt="profile"
                                        style={{ maxWidth: 100, marginTop: 10 }}
                                    />
                                )}
                            </>
                        ) : (
                            form.profile_picture && (
                                <img
                                    src={form.profile_picture.startsWith("http") ? form.profile_picture : `${getAPIbaseURL()}${form.profile_picture}`}
                                    alt="profile"
                                    style={{ maxWidth: 100 }}
                                />
                            )
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Phone Number</th>
                    <td>
                        <input
                            className="form-control"
                            name="phone_number"
                            value={form.phone_number || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Date of Birth</th>
                    <td>
                        <input
                            type="date"
                            className="form-control"
                            name="date_of_birth"
                            value={form.date_of_birth ? form.date_of_birth.slice(0, 10) : ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Country</th>
                    <td>
                        {editMode ? (
                            <select
                                className="form-select"
                                name="country"
                                value={form.country || ""}
                                onChange={handleInputChange}
                            >
                                {countries.map((country) => (
                                    <option key={country} value={country}>{country}</option>
                                ))}
                            </select>
                        ) : (
                            form.country
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Region</th>
                    <td>
                        <input
                            className="form-control"
                            name="region"
                            value={form.region || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>City</th>
                    <td>
                        <input
                            className="form-control"
                            name="city"
                            value={form.city || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Locality</th>
                    <td>
                        <input
                            className="form-control"
                            name="locality"
                            value={form.locality || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Postal Code</th>
                    <td>
                        <input
                            className="form-control"
                            name="postal_code"
                            value={form.postal_code || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Position</th>
                    <td>
                        <input
                            className="form-control"
                            name="position"
                            value={form.position || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Team Tag</th>
                    <td>
                        <input
                            className="form-control"
                            name="team_tag"
                            value={form.team_tag || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Emergency Contact Name</th>
                    <td>
                        <input
                            className="form-control"
                            name="emergency_contact_name"
                            value={form.emergency_contact_name || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Emergency Contact Phone</th>
                    <td>
                        <input
                            className="form-control"
                            name="emergency_contact_phone"
                            value={form.emergency_contact_phone || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Hiring Date</th>
                    <td>
                        <input
                            type="date"
                            className="form-control"
                            name="hiring_date"
                            value={form.hiring_date ? form.hiring_date.slice(0, 10) : ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Seniority Level</th>
                    <td>
                        <input
                            className="form-control"
                            name="seniority_level"
                            value={form.seniority_level || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Social Security Number</th>
                    <td>
                        <input
                            className={`form-control ${errors.social_security_number && (touched.social_security_number || editMode) ? "is-invalid" : ""}`}
                            name="social_security_number"
                            value={form.social_security_number || ""}
                            onChange={handleInputChange}
                            disabled={!editMode}
                        />
                        {errors.social_security_number && (touched.social_security_number || editMode) && (
                            <div className="invalid-feedback">{errors.social_security_number}</div>
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Manager</th>
                    <td>
                        {editMode ? (
                            <select
                                className="form-select"
                                name="manager_id"
                                value={form.manager_id || ""}
                                onChange={handleInputChange}
                            >
                                <option value="">Select a manager</option>
                                {managers.map((manager) => (
                                    <option key={manager.id} value={manager.id}>
                                        {manager.username || manager.email || `Manager ${manager.id}`}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            managers.find(m => m.id === form.manager_id)?.username || form.manager_id
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Created At</th>
                    <td>
                        <input
                            className="form-control"
                            value={form.created_at ? form.created_at.slice(0, 19).replace("T", " ") : ""}
                            disabled
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default UserForm;
